import type { ComponentProps } from 'react'
import { cn } from '~/lib/utils'

export const SidebarLayoutWrapper = ({
	className,
	...props
}: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('flex flex-col gap-6 md:flex-row', className)}
	/>
)

export const SidebarLayoutContent = ({
	className,
	...props
}: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('min-w-0 flex-1', className)}
	/>
)

export const SidebarLayoutSidebar = ({
	className,
	...props
}: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('shrink-0 md:w-[370px]', className)}
	/>
)
